import {AfterViewInit, ChangeDetectionStrategy, Component, OnInit, ViewChild} from '@angular/core';
import {LogItemModel} from "@app/model/log-item.model";
import {HttpClient} from "@angular/common/http";
import {LoginService} from "@app/login/login.service";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {AlertsService} from "@app/utilities/alerts.service";
import * as lodash from 'lodash'
import {ExportTableComponent} from "@app/commons/export-table/export-table.component";
import {MatDialog, MatDialogConfig, MatDialogRef} from "@angular/material/dialog";
import {FormatDatePipe} from "@app/pipes/format-date/format-date.pipe";
import {BehaviorSubject} from "rxjs";
import {CreditUnion} from "@app/pages/admin/admin.component";
import {CreditUnionService} from "@app/services/credit-union/credit-union.service";
import {TicketsService, TicketUser} from "@app/services/tickets/tickets.service";
import {GlobalSpinnerService} from "@app/services/misc-services/global-spinner.service";


@Component({
    selector: 'flex-logs',
    templateUrl: './logs.component.html',
    styleUrls: ['./logs.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogsComponent implements OnInit, AfterViewInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    cuid: string;
    columns: string[] = ['startTime','ticketNumber', 'action', 'user', 'reason'];
    displayedColumns: Array<{ label: string, value: string }> = [
        // {label: 'Date', value: 'startTime'},
        {label: 'Start - End', value: 'startTime'},
        {label: 'Ticket', value: 'ticketNumber'},
        {label: 'Action', value: 'action'},
        {label: 'User', value: 'user'},
        {label: 'Reason', value: 'reason'}];
    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    selectedFilter: string;
    today: Date;
    startFilter: Date;
    endFilter: Date;
    exportTableDialogRef: MatDialogRef<ExportTableComponent>;
    exportTableDialogConfig = new MatDialogConfig();
    allUsers: BehaviorSubject<TicketUser[]> = new BehaviorSubject<TicketUser[]>([]);
    creditUnions: BehaviorSubject<CreditUnion[]> = new BehaviorSubject<CreditUnion[]>([]);

    constructor(private http: HttpClient, public loginService: LoginService, public snackBar: AlertsService,
                private formatDatePipe: FormatDatePipe, public dialog: MatDialog, private creditUnionService: CreditUnionService,
                private globalSpinnerService: GlobalSpinnerService,
                private ticketService:TicketsService) {

    }

    ngOnInit(): void {
        this.getUsers();
        this.setCuid();
        this.getLogItems();
        this.selectedFilter = 'all'
        this.dataSource.filterPredicate = (data: any, dateFilterString: string) => {
            let dateFilter: { startDate: number, endDate: number } = JSON.parse(dateFilterString);
            if (dateFilter.startDate <= this.today.getTime()) {
                return dateFilter.startDate <= (new Date(data.startTime).getTime()) &&
                    dateFilter.endDate >= (new Date(data.startTime).getTime())
            }
            return true;
        }
        this.today = new Date()
        this.today.setHours(23)
        this.today.setMinutes(59)
        this.today.setSeconds(59)
        this.endFilter = this.today;
        if (this.loginService.activeUser.cuid === 'CMC') {
            this.loadCreditUnions();
        }
    }

    ngAfterViewInit() {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;

    }

    setCuid() {
        this.cuid = this.loginService.activeUser.cuid;
    }

    getLogItems() {
        this.globalSpinnerService.addEvent('getAllLogIns', 'Get All The logins for logs');
        // this.http.get(`/api/secured/dialIn/findDialInByCUID/${this.cuid}`).subscribe((log: LogItemModel[]) => {
        //         console.log(log, "RAWR0")
        //     },
        //     error => {
        //         this.snackBar.getError('Error: ' + error.status + ' ' + error.statusText, 'X')
        //         this.globalSpinnerService.removeEvent('getAllLogIns');
        //     })
        this.ticketService.retrieveAccessLogByCUID(this.cuid).subscribe((log: LogItemModel[]) => {
                this.dataSource.data = log;
                this.globalSpinnerService.removeEvent('getAllLogIns');
            },
            error => {
                this.snackBar.getError('Error: ' + error.status + ' ' + error.statusText, 'X')
                this.globalSpinnerService.removeEvent('getAllLogIns');
            })
    }

    filter(type: string) {
        this.endFilter = lodash.clone(this.today);
        this.startFilter = lodash.clone(this.today);
        this.selectedFilter = type;
        this.setStartFilter();
        this.dataSource.filter = JSON.stringify({
            startDate: this.startFilter.getTime(),
            endDate: this.endFilter.getTime()
        });
    }

    private setStartFilter() {
        switch (true) {
            case this.selectedFilter === 'all':
                this.startFilter.setDate(this.startFilter.getDate() + 1);
                break;
            case this.selectedFilter === 'today':
                this.startFilter.setDate(this.startFilter.getDate() - 1);
                break;
            case this.selectedFilter === 'yesterday':
                this.startFilter.setDate(this.startFilter.getDate() - 2);
                break;
            case this.selectedFilter === 'week':
                this.startFilter.setDate(this.startFilter.getDate() - 8);
                break;
            case this.selectedFilter === 'month':
                this.startFilter.setDate(this.startFilter.getDate() - 1);
                this.startFilter.setMonth(this.startFilter.getMonth() - 1);
                break;
        }
    }

    onDateChange() {
        // console.log(this.endFilter);
        if (this.endFilter !== null) {
            this.endFilter.setHours(23)
            this.endFilter.setMinutes(59)
            this.endFilter.setSeconds(59)
          this.dataSource.filter = JSON.stringify({
            startDate: this.startFilter?.getTime(),
            endDate: this.endFilter?.getTime()
          });
        }
    }

    export() {
        this.exportTableDialogConfig.data = {
            displayedColumns: this.displayedColumns,
            selectedUsers: this.dataSource.filteredData
        }
        this.exportTableDialogConfig.width = '1000px';
        this.exportTableDialogConfig.height = 'auto';
        this.exportTableDialogRef = this.dialog.open(ExportTableComponent, this.exportTableDialogConfig);
    }

    private loadCreditUnions() {
        this.creditUnionService.getAllCreditUnions().subscribe((creditUnions: CreditUnion[]) =>
            this.creditUnions.next(creditUnions))
    }

    private getUsers() {
        this.http.get('/api/secured/ticket/assignee/list').subscribe((ticketUsers:TicketUser[])=> {
            this.allUsers.next(ticketUsers)
        });
    }
}
